import { invariant } from "../../../../../Global/Base/Utils/AssertUtils";
import { ActionContext, ActionType } from "../../../../UI.Controls/Actions/IAction";
import { IFrame } from "../IFrame";
import { StandardAction } from "./StandardAction";

type RecordAction = (event: Event, dataKey: string) => Promise<void>;

/**
 * Standardní akce, která se spouští nad záznamem a která potřebuje dostat jeho identifikátor
 */
export class StandardRecordAction extends StandardAction {
    private _recordAction: RecordAction | null;

    /**
     * Vytvoří standardní akci, která se spouští nad datovým záznamem
     * @param actionType Typ vytvářené akce
     * @param recordAction Akce spouštěná nad záznamem
     * @param locKey Lokalizační klíč pro popisek akce
     */
    constructor(actionType: ActionType, recordAction: (event: Event, dataKey: string) => Promise<void>, locKey: string, context: ActionContext = ActionContext.objectAction, priority: number = 1, owner?: IFrame) {
        super(actionType, null, locKey, context, priority, owner);
        this._recordAction = recordAction;
        this.enabled = false; //na zacatku se vsechny akce nastavi na neaktivni
    }

    public get recordAction(): RecordAction {
        invariant(this._recordAction, "Cannot get record action of disposed StandardRecordAction.");
        return this._recordAction;
    }

    public override dispose(): void {
        this._recordAction = null;
        super.dispose();
    }
}
